import React from "react";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  toast as baseToast,
  type ToastContent,
  type ToastOptions,
} from "react-toastify";

const successIcon = (
  <CheckCircleOutlineOutlinedIcon
    sx={{ width: 24, height: 24, color: "#00000099" }}
    aria-hidden
  />
);

const errorIcon = (
  <InfoOutlinedIcon
    sx={{ width: 24, height: 24, color: "#00000099" }}
    aria-hidden
  />
);

function withMuiDefaultIcons(options?: ToastOptions): ToastOptions | undefined {
  if (!options) {
    return undefined;
  }
  if (options.type === "success" && options.icon == null) {
    return { ...options, icon: successIcon };
  }
  if (options.type === "error" && options.icon == null) {
    return { ...options, icon: errorIcon };
  }
  return options;
}

function mainToast(content: ToastContent, options?: ToastOptions) {
  return baseToast(content, withMuiDefaultIcons(options));
}

export const toast = Object.assign(mainToast, baseToast, {
  success(content: ToastContent, options?: ToastOptions) {
    return baseToast.success(
      content,
      options?.icon == null ? { ...options, icon: successIcon } : options,
    );
  },
  error(content: ToastContent, options?: ToastOptions) {
    return baseToast.error(
      content,
      options?.icon == null ? { ...options, icon: errorIcon } : options,
    );
  },
}) as typeof baseToast;
